module.exports = __webpack_public_path__ + "static/media/mapDetailsInactive.243551f2.png";